import { Injectable } from '@angular/core';
import { ChatGroup } from '@models/Chat/ChatGroup';
import { GroupMsg } from '@models/Chat/GroupMsg';
import { User } from '@models/Core/User';
import { Idea } from '@models/Sessions/Idea/Idea';
import { Session } from '@models/Sessions/Session';
import { map, share } from 'rxjs/operators';

import { RequestService } from '../request.service';

@Injectable()
export class GroupChatService {
  api = {
    root: '/chat',
    messages: '/msg',
    generalPosters: '/general-group-posters/',
  };

  constructor(private client: RequestService) {}

  getGroupBySession(session: Session) {
    return this.client.get<ChatGroup>({
      uri: this.api.root + '?session=' + session._id,
      handlers: {
        error: () => void 0,
        success: () => void 0,
      },
    });
  }

  getGroupByIdea(session: Session, idea: Idea) {
    return this.client.get<ChatGroup>({
      uri: this.api.root + '?session=' + session._id + '&idea=' + idea._id,
      handlers: {
        error: () => void 0,
        success: () => void 0,
      },
    });
  }

  getGeneralGroup() {
    return this.client.get<ChatGroup>({
      uri: this.api.root,
      handlers: {
        error: () => void 0,
        success: () => void 0,
      },
    });
  }

  getGeneralGroupPosters() {
    return this.client.get<User[]>({
      uri: this.api.root + this.api.generalPosters,
      handlers: {
        error: () => void 0,
        success: () => void 0,
      },
    });
  }

  messages(group: ChatGroup) {
    return this.client
      .get<GroupMsg[]>({
        uri: this.api.root + '/' + (group._id || '') + this.api.messages,
        handlers: {
          error: () => void 0,
          success: () => void 0,
        },
      })
      .pipe(
        map(msgs =>
          msgs.map(msg => {
            msg.created_at = new Date(msg.created_at);
            return msg;
          }),
        ),
        share(),
      );
  }

  send(group: ChatGroup, msg: string) {
    return this.client.post({
      uri: this.api.root + '/' + (group._id || '') + this.api.messages,
      body: { msg },
      handlers: {
        error: () => void 0,
        success: () => void 0,
      },
    });
  }

  delete(group: ChatGroup, msg: GroupMsg) {
    return this.client.delete({
      uri:
        this.api.root +
        '/' +
        (group._id || '') +
        this.api.messages +
        '/' +
        msg._id,
      handlers: {
        error: () => void 0,
        success: () => void 0,
      },
    });
  }

  announce(group: ChatGroup, msg: string) {
    return this.client.post({
      uri: this.api.root + '/' + (group._id || '') + this.api.messages,
      body: { msg, announcement: true },
      handlers: {
        error: () => void 0,
        success: () => void 0,
      },
    });
  }
}
